import { ImgHTMLAttributes } from 'react';
import Asset from '@/components/asset';

export default function Img(props: ImgHTMLAttributes<HTMLImageElement>) {
    return <Asset element={'img'} {...props} />;
}
